<template>
	<el-popover
		class="popover-text"
		placement="top-start"
		trigger="hover"
		:width="width"
		:content="subText || getData()"
		:disabled="disabled"
	>
		<component
			:is="colType"
			:scope="scope"
			:tableData="tableData"
			:bind="bind"
			v-bind="tableData"
		></component>
		<div style="text-align: left;" align="middle" slot="reference">
			<el-button
				v-if="clickFn"
				type="text"
				@click="clickBtn"
				class="text"
				:style="{ '-webkit-line-clamp': line }"
				>{{ text || getData() }}
			</el-button>
			<p v-else class="text-item" :style="[textStyle]">
				{{ text || getData() }}
			</p>
			<slot></slot>
		</div>
	</el-popover>
</template>
<script>
import account from '@/components/iglobalwin/dataList/account/index.js';
import serviceInfo from '@/components/customer/serviceInfo.vue';

import popoverContent from '@/components/iglobalwin/dataList/popoverContent.vue';
import transTextFormat from '@/components/iglobalwin/dataList/account/transTextFormat.vue';
export default {
	name: 'popover-text',
	props: {
		clickFn: Function,
		text: [Number, String],
		subText: [Number, String],
		colType: [String, Object],
		scope: Object,
		tableData: [Object, Array],
		bind: [String, Object],
		disabled: Boolean,
		textStyle: Object,
		width: {
			type: String,
			default: 'auto',
		},
		line: {
			type: [Number, String],
			default: 1,
		},
	},
	data() {
		return {};
	},
	methods: {
		clickBtn() {
			this.clickFn(this.text, this.subText);
		},
		getData() {
			let { scope, tableData, bind } = this;
			if (!(scope && tableData && bind)) return '';
			if (tableData.getData) {
				return tableData.getData(scope.row, bind, tableData);
			}
			return scope.row[bind];
		},
	},
	components: {
		...account,
		serviceInfo,
		popoverContent,
		transTextFormat,
	},
};
</script>
<style lang="scss" scoped>
.text-item {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  line-height: 1.5em;
  word-break: break-all;
}
</style>
<style lang="scss">
.el-popover.el-popper.el-popover--plain {
  word-break: break-all;
}

.popover-text .text {
  overflow: hidden !important;
  line-height: 1.5em;
  text-overflow: ellipsis !important;
  padding: 0;
}
</style>
